export const fallbackLang = 'es';
export const defaultNS = 'common';
export const LANGUAGE_STORAGE_KEY = 'i18next';
export const localStorageName = 'i18nextLocal';
export const languages = ['en', 'es', 'pt', 'fr', 'it', 'de', 'el', 'vi', 'ru', 'cn', 'ar', 'ja'];

export const i18nOptions = (lng = fallbackLang, ns = defaultNS) => ({
  // debug: true,
  lng,
  fallbackLang,
  ns,
  defaultNS,
  fallbackNS: defaultNS,
  supportedLngs: languages,
});

export const changeLangMessages = {
  en: {
    success: 'Language has been changed',
    error: 'Error changing language',
    loading: 'Loading...',
  },
  es: {
    success: 'Se ha cambiado el idioma',
    error: 'Error al cambiar el idioma',
    loading: 'Cargando...',
  },
  pt: {
    success: 'O idioma foi alterado',
    error: 'Erro ao alterar o idioma',
    loading: 'Carregando...',
  },
  fr: {
    success: 'La langue a été changée',
    error: 'Erreur lors du changement de langue',
    loading: 'Chargement...',
  },
  it: {
    success: 'La lingua è stata cambiata',
    error: 'Errore nel cambio lingua',
    loading: 'Ricarica...',
  },
  de: {
    success: 'Die Sprache wurde geändert',
    error: 'Fehler beim Ändern der Sprache',
    loading: 'Aufladen...',
  },
  el: {
    success: 'Η γλώσσα έχει αλλάξει',
    error: 'Σφάλμα αλλαγής γλώσσας',
    loading: 'Φόρτιση...',
  },
  vi: {
    success: 'Ngôn ngữ đã được thay đổi',
    error: 'Lỗi khi thay đổi ngôn ngữ',
    loading: 'Đang tải...',
  },
  ru: {
    success: 'Язык изменен',
    error: 'Ошибка смены языка',
    loading: 'Зарядка...',
  },
  cn: {
    success: '语言已更改',
    error: '更改语言时出错',
    loading: '加载中...',
  },
  ar: {
    success: 'تم تغيير اللغة',
    error: 'خطأ في تغيير اللغة',
    loading: 'جارٍ التحميل...',
  },
  ja: {
    success: '言語が変更されました',
    error: '言語変更中にエラーが発生しました',
    loading: '充電...',
  },
};
